export default __webpack_public_path__ + "static/6.berries@2x-9576dc21df74d6e621ffb35f8632b6f9.png";